module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.49f89e34.ttf";